import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { StatusLabel } from '../StatusLabel';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const OpenStatusLabel: React.FC = () => {
    const { t } = useLanguageLocale();

    return (
        <StatusLabel
            status={t('DASHBOARD.TIMELINE_DETAILS.OPEN')}
            foregroundColor={PXBColors.white[500]}
            backgroundColor={PXBColors.red[500]}
            testId="open-status-label"
        />
    );
};
